import { useState, useEffect } from "react";
import cn from "clsx";
import { observer } from "mobx-react";
import styles from "./index.module.scss";

interface countDownProps {
  endTime: number;
  size?: string;
  externalStyles?: React.CSSProperties;
  endHandler?: () => void;
}

const countDown: React.FC<countDownProps> = observer(
  ({ endTime, size, externalStyles, endHandler }) => {
    const [timeLeft, setTimeLeft] = useState(endTime);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
      if (timeLeft <= 0) {
        return;
      }
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          // 倒计时结束
          if (prevTime <= 1) {
            clearInterval(timer); // 清除定时器
            endHandler && endHandler();
            return 0; // 确保时间设置为 0
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }, [timeLeft, endHandler]);

    // 更新时、分、秒
    useEffect(() => {
      const hrs = Math.floor(timeLeft / 3600);
      const mins = Math.floor((timeLeft % 3600) / 60);
      const secs = timeLeft % 60;

      setHours(hrs);
      setMinutes(mins);
      setSeconds(secs);
    }, [timeLeft]);

    function formatNumber(num: number) {
      return num < 10 ? `0${num}` : `${num}`;
    }

    if (endTime < 0) {
      return null;
    }

    return (
      <div
        className={cn(styles.countdown_part_box, { [styles.countdown_part_large_box]: size })}
        style={externalStyles}
      >
        <div className={styles.part_item}>{formatNumber(hours)}</div>
        <span className={styles.part_item_symbol}>:</span>
        <div className={styles.part_item}>{formatNumber(minutes)}</div>
        <span className={styles.part_item_symbol}>:</span>
        <div className={styles.part_item}>{formatNumber(seconds)}</div>
      </div>
    );
  },
);

export default countDown;
